export default {"src":"/_next/static/media/figo_icon_light_aoc_termin.1e4444ed.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};